import {
    faEdit,
    faExclamation,
    faPlus,
    faSearch,
    faTrash,
    faStar
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import {
    getEmpleados,
    guardarEmpleado,
    validarDni,
    actualizarEmpleado,
    eliminarEmpleado
} from "../../../services/empleadoservice";

// estilos exclusivos de Empleado
import "./Empleado.css";

export default function Empleado() {

    const userData = JSON.parse(localStorage.getItem("user"));

    const [modalNuevoOpen, setModalNuevoOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    const [empleados, setEmpleados] = useState([]);
    const [busqueda, setBusqueda] = useState("");

    const [empleado, setEmpleado] = useState({
        idempleado: 0,
        nombre: "",
        dni: "",
        fechainicio: "",
        especialidad: "",
        tarifa: "",
        telefono: ""
    });

    // =========================
    // CARGAR
    // =========================

    const cargarEmpleados = async () => {

        try {

            const data = await getEmpleados();

            if (!data) {
                toast.error("No hay empleados");
                return;
            }

            setEmpleados(data);

        } catch (error) {

            console.error(error);
            toast.error("Error cargando empleados");
        }
    };

    useEffect(() => {
        cargarEmpleados();
    }, []);

    // =========================
    // VALIDAR DNI
    // =========================

    const handleValidar = async () => {

        if (empleado.idempleado !== 0) return;

        const dni = empleado.dni?.trim();

        if (!dni || dni.length !== 8) return;

        try {

            const res = await validarDni(dni);

            if (res?.status === "exists") {

                toast.warning(`El DNI ${dni} ya existe`);

                setEmpleado(prev => ({
                    ...prev,
                    dni: "",
                    nombre: ""
                }));

                return;
            }

            if (res?.nombres) {

                setEmpleado(prev => ({
                    ...prev,
                    nombre:
                        `${res.nombres} ${res.apellidoPaterno} ${res.apellidoMaterno}`
                }));

                toast.success("DNI validado");
                return;
            }

            toast.error("DNI no encontrado");

        } catch (error) {

            console.error(error);
            toast.error("Error validando DNI");
        }
    };

    // =========================
    // FILTRO
    // =========================

    const empleadosFiltrados = empleados.filter(item => {

        const texto = busqueda.toLowerCase();

        return (
            item.nombre?.toLowerCase().includes(texto) ||
            item.dni?.includes(texto) ||
            item.especialidad?.toLowerCase().includes(texto)
        );
    });

    const itemsActuales = empleadosFiltrados;

    // =========================
    // GUARDAR
    // =========================

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (
            !empleado.dni ||
            !empleado.nombre ||
            !empleado.fechainicio ||
            !empleado.especialidad ||
            !empleado.tarifa ||
            !empleado.telefono
        ) {
            toast.error("Todos los campos son obligatorios");
            return;
        }

        try {

            const payload = {
                ...empleado,
                idusuario: userData?.idusuario
            };

            let result;

            if (empleado.idempleado === 0) {
                result = await guardarEmpleado(payload);
            } else {
                result = await actualizarEmpleado(payload);
            }

            if (result?.status === "success") {

                toast.success("Operación exitosa");

                setModalNuevoOpen(false);

                setEmpleado({
                    idempleado: 0,
                    nombre: "",
                    dni: "",
                    fechainicio: "",
                    especialidad: "",
                    tarifa: "",
                    telefono: ""
                });

                cargarEmpleados();

            } else {

                toast.error(result?.message || "Error");
            }

        } catch (error) {

            console.error(error);
            toast.error("Error servidor");
        }
    };

    // =========================
    // EDITAR
    // =========================

    const handleEdit = (item) => {

        setEmpleado(item);

        setModalNuevoOpen(true);
    };

    // =========================
    // ELIMINAR
    // =========================

    const borrarEmpleado = async () => {

        try {

            const res = await eliminarEmpleado({
                idempleado: empleado.idempleado,
                idusuario: userData.idusuario
            });

            if (res?.status === "success") {

                toast.success("Empleado eliminado");

                setDeleteModalOpen(false);

                cargarEmpleados();

            } else {

                toast.error("Error al eliminar");
            }

        } catch (error) {

            console.error(error);
            toast.error("Error servidor");
        }
    };

    return (
        <div className="main-content">

            <ToastContainer />

            {/* HEADER */}

            <div className="nuevo-container">

                <div className="search-wrapper">

                    <FontAwesomeIcon
                        icon={faSearch}
                        className="search-icon"
                    />

                    <input
                        className="search-input"
                        placeholder="Buscar empleado..."
                        value={busqueda}
                        onChange={(e) => {
                            setBusqueda(e.target.value);
                        }}
                    />

                </div>

                <button
                    className="nuevo"
                    onClick={() => {

                        setEmpleado({
                            idempleado: 0,
                            nombre: "",
                            dni: "",
                            fechainicio: "",
                            especialidad: "",
                            tarifa: "",
                            telefono: ""
                        });

                        setModalNuevoOpen(true);
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} />
                    {" "}Nuevo Empleado
                </button>

            </div>

            {/* TABLA */}

            <div className="table-container">

                <table className="table">

                    <thead>

                        <tr>
                            <th>ID</th>
                            <th>Empleado</th>
                            <th>DNI</th>
                            <th>Fecha Inicio</th>
                            <th>Especialidad</th>
                            <th>Tarifa</th>
                            <th>Teléfono</th>
                            <th>Acciones</th>
                        </tr>

                    </thead>

                    <tbody>

                        {itemsActuales.length > 0 ? (

                            itemsActuales.map(item => (

                                <tr key={item.idempleado}>

                                    <td>{item.idempleado}</td>

                                    <td>
                                        <span className="nombre-resaltado">
                                            {item.nombre}
                                        </span>
                                    </td>

                                    <td>{item.dni}</td>

                                    <td>{item.fechainicio}</td>

                                    <td>
                                        <span className="badge-especialidad">
                                            <FontAwesomeIcon icon={faStar} />
                                            {" "}
                                            {item.especialidad}
                                        </span>
                                    </td>

                                    <td>
                                        S/ {item.tarifa}
                                    </td>

                                    <td>{item.telefono}</td>

                                    <td>

                                        <button
                                            className="editar"
                                            onClick={() => handleEdit(item)}
                                        >
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>

                                        <button
                                            className="eliminar"
                                            onClick={() => {
                                                setEmpleado(item);
                                                setDeleteModalOpen(true);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>

                                    </td>

                                </tr>

                            ))

                        ) : (

                            <tr>
                                <td colSpan="8" style={{ textAlign: "center" }}>
                                    No hay empleados registrados
                                </td>
                            </tr>

                        )}

                    </tbody>

                </table>

            </div>

            {/* MODAL */}

            {modalNuevoOpen && (

                <div
                    className="modalOverlay"
                    onClick={() => setModalNuevoOpen(false)}
                >

                    <div
                        className="modalWindow"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div className="modalHeader">
                            <h2>Empleado</h2>
                        </div>

                        <div className="modalBody">

                            <div className="modalRow">

                                <input
                                    className="input-modal"
                                    placeholder="DNI"
                                    maxLength={8}
                                    value={empleado.dni}
                                    disabled={empleado.idempleado !== 0}
                                    onBlur={handleValidar}
                                    onChange={(e) =>
                                        setEmpleado({
                                            ...empleado,
                                            dni: e.target.value
                                        })
                                    }
                                />

                                <input
                                    className="input-modal"
                                    placeholder="Nombre"
                                    value={empleado.nombre}
                                    disabled
                                />

                            </div>

                            <div className="modalRow">

                                <input
                                    type="date"
                                    className="input-modal"
                                    value={empleado.fechainicio}
                                    onChange={(e) =>
                                        setEmpleado({
                                            ...empleado,
                                            fechainicio: e.target.value
                                        })
                                    }
                                />

                                <input
                                    className="input-modal"
                                    placeholder="Teléfono"
                                    value={empleado.telefono}
                                    onChange={(e) =>
                                        setEmpleado({
                                            ...empleado,
                                            telefono: e.target.value
                                        })
                                    }
                                />

                            </div>

                            <div className="modalRow">

                                <input
                                    className="input-modal"
                                    placeholder="Especialidad"
                                    value={empleado.especialidad}
                                    onChange={(e) =>
                                        setEmpleado({
                                            ...empleado,
                                            especialidad: e.target.value
                                        })
                                    }
                                />

                                <input
                                    type="number"
                                    className="input-modal"
                                    placeholder="Tarifa"
                                    value={empleado.tarifa}
                                    onChange={(e) =>
                                        setEmpleado({
                                            ...empleado,
                                            tarifa: e.target.value
                                        })
                                    }
                                />

                            </div>

                        </div>

                        <div className="modalFooter">

                            <button
                                className="modalBtn btnCancelar"
                                onClick={() => setModalNuevoOpen(false)}
                            >
                                Cancelar
                            </button>

                            <button
                                className="modalBtn btnGuardar"
                                onClick={handleSubmit}
                            >
                                Guardar
                            </button>

                        </div>

                    </div>

                </div>

            )}

            {/* DELETE */}

            {deleteModalOpen && (

                <div
                    className="modalOverlay"
                    onClick={() => setDeleteModalOpen(false)}
                >

                    <div
                        className="modalWindow deleteStyle"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div className="deleteHeader">
                            <button
                                className="deleteCloseX"
                                onClick={() => setDeleteModalOpen(false)}
                            >
                                ×
                            </button>
                        </div>

                        <div className="deleteIconContainer">
                            <div className="deleteIconCircle">
                                <FontAwesomeIcon icon={faExclamation} />
                            </div>
                        </div>

                        <div className="deleteBodyContent">

                            <h3 className="deleteTitle">
                                ¿Eliminar empleado?
                            </h3>

                            <p className="deleteText">
                                El empleado
                                {" "}
                                <b>{empleado?.nombre}</b>
                                {" "}
                                será eliminado permanentemente.
                            </p>

                            <div className="deleteActions">

                                <button
                                    className="btnCancelGhost"
                                    onClick={() => setDeleteModalOpen(false)}
                                >
                                    Cancelar
                                </button>

                                <button
                                    className="btnConfirmFilled"
                                    onClick={borrarEmpleado}
                                >
                                    Confirmar
                                </button>

                            </div>

                        </div>

                    </div>

                </div>

            )}

        </div>
    );
}